import { CpmChip, CpmTooltip } from '../../../components/design-system';

interface ChipOverflowProps {
    items: string[];
    max?: number;
    emptyLabel?: string;
}

export default function ChipOverflow({ items, max = 2, emptyLabel }: ChipOverflowProps) {
    if (items.length === 0) {
        return (
            <span
                style={{
                    fontSize: 12.5,
                    fontWeight: 600,
                    color: 'var(--cpm-text-tertiary)',
                }}
            >
                {emptyLabel ?? '—'}
            </span>
        );
    }
    const shown = items.slice(0, max);
    const extra = items.length - shown.length;
    return (
        <div className="flex flex-wrap items-center" style={{ gap: 5 }}>
            {shown.map((item) => (
                <CpmChip key={item} variant="tag">
                    {item}
                </CpmChip>
            ))}
            {extra > 0 ? (
                <CpmTooltip content={items.join(', ')} align="start" fit>
                    <span
                        style={{
                            fontSize: 11,
                            fontWeight: 800,
                            color: 'var(--cpm-brand-purple)',
                            background: 'var(--cpm-purple-tint-13)',
                            borderRadius: 'var(--cpm-radius-full)',
                            padding: '3px 7px',
                        }}
                    >
                        +{extra}
                    </span>
                </CpmTooltip>
            ) : null}
        </div>
    );
}
